import React from 'react'

import Navigation from '../../components/navigation'

export default () => (
  <section>
    <header>
      <h1>Index</h1>
    </header>
    <Navigation />
  </section>
)



/** WEBPACK FOOTER **
 ** ./pub/client/routes/IndexPage/index.js
 **/